import type { StarRatingProps, FieldProps } from '@mfw/components';

import { StarRating, get } from '@mfw/components';
import { type FieldError, Controller } from 'react-hook-form';

export type FormStarRatingProps = StarRatingProps & FieldProps;

export const FormStarRating = ({
  loading,
  name,
  ...props
}: FormStarRatingProps) => {
  return (
    <Controller
      render={({ field, formState: { errors } }) => {
        const error = get<FieldError>(errors, name) ?? undefined;
        return (
          <StarRating
            {...props}
            loading={loading}
            errors={error?.message}
            {...field}
            onChange={(_, value) => {
              field.onChange(value);
            }}
          />
        );
      }}
      name={name}
    />
  );
};

export default FormStarRating;
